require('./brokerWarrantsAdvancedSellStep3.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { THIRD_STEP } = require('constants/index');

// @commons
const AdvancedBuySellWarrantSummary = require('components/broker/commons/advancedBuySellWarrantSummary/advancedBuySellWarrantSummary');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');

class BrokerWarrantsAdvancedSellStep3 extends React.Component {
    render() {
        const { immProductFile, immBrokerWarrantsAdvancedSell, immStocksContract } = this.props;
        const step3 = immBrokerWarrantsAdvancedSell.getIn(['steps', THIRD_STEP]);
        const isMIFIDChecked = step3.get('isMIFIDChecked');
        const MiFIDErrorClasses = classNames('warrants-advanced-buy-step3__mifid-error', {
            hidden: !step3.getIn(['errorFlags', 'mifidCheckMissing'])
        });

        return (
            <div className="warrants-advanced-buy-step3">
                <header className="warrants-advanced-buy-step3__header">
                    <h2 className="warrants-advanced-buy-step3__header-title">
                        {formatText('broker-stocksAdvancedBuyStep3HeaderTitle')}
                    </h2>
                    <p className="warrants-advanced-buy-step3__header-text">
                        {formatText('broker-stocksAdvancedBuyStep3HeaderText')}
                    </p>
                </header>
                <AdvancedBuySellWarrantSummary
                    immProductFile={immProductFile}
                    immBrokerWarrantsAdvancedState={immBrokerWarrantsAdvancedSell}
                    immStocksContract={immStocksContract}
                    isSell={true}
                />
                <section className="warrants-advanced-buy-step3__section">
                    <OKMessage
                        id="warrants-advanced-buy-step3-disclaimer"
                        type="informative"
                        visible={true}
                        extraClass="warrants-advanced-buy-step3__disclaimer"
                    >
                        <FormattedText value="broker-warrantsAdvancedBuyStep3DisclaimerWarning" />
                    </OKMessage>

                    <div className="warrants-advanced-buy-step3__clause-checkbox">
                        <OKCheckbox
                            idName="warrants-advanced-buy-step3-clause"
                            onChange={this.props.handleMifidClauseChanged}
                            label={formatText('broker-warrantsAdvancedBuyStep3CheckboxLabel')}
                            value={isMIFIDChecked}
                        />
                        <FormattedText
                            value="broker-warrantsBuyMiFIDError"
                            className={MiFIDErrorClasses}
                        />
                    </div>
                    <section className="warrants-advanced-buy-step3__clause-section-info-container">
                        <p className="warrants-advanced-buy-step3__clause-section-info">
                            <FormattedText value="broker-warrantsAdvancedBuyStep3Disclaimer" />
                        </p>
                    </section>
                    <p className="warrants-advanced-buy-step3__header-text">
                        {formatText('broker-warrantsAdvancedSellStep3LastWarning')}
                    </p>
                </section>
            </div>
        );
    }
}

BrokerWarrantsAdvancedSellStep3.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedSell: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    handleMifidClauseChanged: PropTypes.func.isRequired
};

module.exports = BrokerWarrantsAdvancedSellStep3;
